import {useState} from 'react';
import {Link, Paper, Tab, Tabs, useTheme} from '@mui/material';
import TabPanel from "../TabPanel/TabPanel";
import PropTypes from "prop-types";

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

const HorizontalCenteredTabs = ({tabs, selectedTab, setSelectedTab}) => {
    const theme = useTheme();
    const backgroundColor = theme.palette.customColor.hwCatalogTabsColor;

    const onSelectedTabChanged = (event, selectedTab) => {
        setSelectedTab(selectedTab);
    };

    return <>
        <Paper sx={{backgroundColor: backgroundColor, mr: 3, ml: 3, mt: 2.5}} elevation={2} square={false}>
            <Tabs value={selectedTab} onChange={onSelectedTabChanged} centered>
                {
                    tabs.map((tab, index) => {
                        return <Tab key={index}
                                    component={Link}
                                    to="#"
                                    sx={{textTransform: 'none', pt: 0, pb: 1}}
                                    icon={tab.icon}
                                    iconPosition="top"
                                    label={tab.label}
                                    {...a11yProps(index)}
                        />
                    })
                }
            </Tabs>
        </Paper>
        {
            tabs.map((tab, index) => {
                return <TabPanel key={index} value={selectedTab} index={index}>
                    {tab.content}
                </TabPanel>
            })
        }
    </>;
}

TabPanel.propTypes = {
    tabs: PropTypes.node,
};


export default HorizontalCenteredTabs;
